export enum FlightJourneyType {
  DIRECT = 'DIRECT',
  MULTI_LEG = 'MULTI_LEG'
}
